import React from "react";
import { Row, Col } from "react-bootstrap";

import AgreementCheckbox from "../../../controls/AgreementCheckbox";

function AgreementBlock() {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Client Agreement <span>*</span></span>
        </div>
      </Col>
      <Col xs={12}>
        <AgreementCheckbox
          id="formAgreement"
          label={(
            <span>
              By checking this box, (i) I represent and warrant that all of the information provided above is accurate and complete; 
              (ii) I agree that I have carefully read and agree to be bound by the Terms of Use and (iii) 
              I have read and understand that I am hereby authorizing irs-taxnumber.org 
              as a third party designee as described in the instructions to Form SS-4 
              to apply to the IRS for the Employer Identification Number of the person or entity listed above, 
              answer any questions on my behalf or the behalf of the entity listed above about the completion of Form SS-4, 
              and to receive and deliver to me the Employer Identification Number for me or the entity listed above.
          </span>
          )}
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default AgreementBlock;
